<template>
	<div>
		<div class="flex-between">
			<div class="header">
				<h2>訂單</h2>
			</div>
		</div>
		<div class="order-description">
			<div class="flex-between">
				<div>訂單編號:</div>
				<div>{{ order.order_sn }}</div>
			</div>
			<div class="flex-between">
				<div>店家名稱:</div>
				<div>{{ order.store_name }}</div>
			</div>
			<div class="flex-between">
				<div>店家地址:</div>
				<div>{{ order.extend_store.store_address }}</div>
			</div>
		</div>
		<!-- <div class="hr-text"></div> -->
		<div class="header" style="margin-top: 5px">
			<h2>訂單項目</h2>
		</div>
		<div class="order-detail">
			<div
				class="flex-between"
				v-for="good in order.extend_order_goods"
				:key="good.id"
			>
				<div class="goods-count">{{ good.goods_num }}x</div>
				<div>{{ good.goods_name }}</div>
				<div>${{ utils.currencyPrice(good.goods_price) }}</div>
			</div>
		</div>
		<div class="hr-text"></div>
		<div class="flex-between">
			<div>{{ $t('order_progress.subtotal_amount') }}:</div>
			<div>${{ utils.currencyPrice(order.goods_amount) }}</div>
		</div>
		<div class="hr-text"></div>
		<div class="flex-between">
			<div>{{ $t('order_progress.total_amount') }}:</div>
			<div>${{ utils.currencyPrice(order.order_amount) }}</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ErrandBuyOrder',
	props: {
		expansion: {
			type: Boolean,
			require: true
		},
		order: {
			type: Object,
			require: true
		}
	}
}
</script>
<style lang='scss'scoped>
$foldBgColor: #f4c41e;
$toggleTabColor: white;
$toggleBorder: #898989;

.flex-between {
	display: flex;
	justify-content: space-between;
}

.header {
	font-size: $h5;
	border: 1px solid #898989;
	width: 100%;
	text-align: center;
}

.order-description {
	padding: 0rem 0.5rem;
    margin-top: 6px;
}

.order-detail {
	padding: 0rem 0.5rem;
	height: 20vh;
	overflow-y: scroll;
}
@media only screen and (min-height: 414px) and (max-height: 736px) {
	.order-detail {
		height: 14vh;
	}
}
@media only screen and (min-height: 812px) and (max-height: 1024px) {
	.order-detail {
		height: 22vh;
	}
}
</style>
